import { getGtagMeasurementId } from "./measurement-id";
import { isStaging } from "./environment";

export default send;

/**
 * Sendet Events Richtung Analytics
 * https://developers.google.com/analytics/devguides/collection/protocol/ga4/sending-events?client_type=gtag#send_an_event
 *
 * @param {object} events - Array/Liste mit 1 - n Events
 *
 */
async function send(events) {
	for (const event of events) {
		const { name, params } = event;
		const gtagMeasurementId = getGtagMeasurementId(isStaging);
		if (!gtagMeasurementId) {
			return;
		}
		const eventparams = {
			...params,
			page_location: window.location.href,
			page_referrer: document.referrer,
			page_title: document.title,
			send_to: gtagMeasurementId
		}
		gtag("event", name, eventparams);
	}
}
